const hashtag = {
  state: {    
    sectionHashtagsReloadFlg : false,
    squareHashtags: null
  },
  getters: {
    sectionHashtagsReloadFlg(state) { return state.sectionHashtagsReloadFlg },
    squareHashtags(state) { return state.squareHashtags },
    
  },
  mutations: {
    setSectionHashtagsReloadFlg (state, value) {
      state.sectionHashtagsReloadFlg = value
    },
    
    setSquareHashtags (state, value) {
      state.squareHashtags = value
    },

  },
  actions: {},
  modules: {}
}
export default hashtag